import { createStylesheetElement } from "./element-helpers";

function injectStylesToIframe(iframe: HTMLIFrameElement) {
  const interval = setInterval(() => {
    if (iframe.contentDocument && iframe.contentDocument.head?.children.length > 0) {
      const sharedStyles = document.querySelectorAll('[data-theme-shared-styles]');
      sharedStyles.forEach((style) => {
        iframe.contentDocument.head.appendChild(style.cloneNode(true));
      });

      const iframeStylesHref = document
        .querySelector(`[data-theme-styles-for="[title='${iframe.title}']"]`)
        ?.getAttribute('data-theme-styles-href');

      if (iframeStylesHref) {
        const iframeStyles = createStylesheetElement(iframeStylesHref);
        iframe.contentDocument.head.appendChild(iframeStyles);
      }

      const bodyClasses = document.body.classList.toString().split(' ');
      iframe.contentDocument.body.classList.add(...bodyClasses);

      // Add data-theme attribute handling
      const parentTheme = document.body.getAttribute('data-theme');
      if (parentTheme) {
        iframe.contentDocument.body.setAttribute('data-theme', parentTheme);
      }

      clearInterval(interval);
    }
  }, 10);
}

function observeDataThemeChanges(iframe: HTMLIFrameElement) {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'data-theme') {
        const parentTheme = document.body.getAttribute('data-theme');
        if (iframe.contentDocument && iframe.contentDocument.body) {
          if (parentTheme) {
            iframe.contentDocument.body.setAttribute('data-theme', parentTheme);
          } else {
            iframe.contentDocument.body.removeAttribute('data-theme');
          }
        }
      }
    });
  });

  observer.observe(document.body, { attributes: true, attributeFilter: ['data-theme'] });
}

function observeIframeAdded(callback: (iframe: HTMLIFrameElement) => void) {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node: HTMLElement) => {
        const iframe = node?.tagName === 'iframe' ? node : node?.querySelector?.('iframe');
        if (iframe) {
          callback(iframe as HTMLIFrameElement);
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

export function setupIframeStyles() {
  observeIframeAdded((iframe) => {
    injectStylesToIframe(iframe);
    observeDataThemeChanges(iframe);
  });
}
